import { APINodeClient } from './apiNodeCore';

const api = new APINodeClient();


export const getAvailableRoomsApi = async (response: any) => {
  return api.create('/available/find-all-available-rooms',response);
};


